<div class="app-container">
  <ng-container *ngIf="translationsLoaded">
   <ng-container *ngIf="isLoggedIn && !currentUrl.startsWith('/login'); else loggedOut">
      <a class="skip-link" href="#main-content" (click)="skipToMainContent($event, mainContent)">Skip to main content</a>
      <mat-sidenav-container class="sidenav-container">
        <mat-sidenav #sidenav 
          [mode]="isMobileOrTablet ? 'over' : 'side'"
          [opened]="!isMobileOrTablet || sidenavOpened"
          class="sidenav" 
          (closedStart)="sidenavOpened = false">
          <app-side-nav [isMobileOrTablet]="isMobileOrTablet" (closeSidenav)="closeSidenav()"></app-side-nav>
        </mat-sidenav>
        <mat-sidenav-content>
          <app-header class="header-bar"
            [title]="title"
            [isMobileOrTablet]="isMobileOrTablet"
            [sidenavOpened]="sidenavOpened"
            (openSidenavClicked)="openSidenav()"
          ></app-header>
          <main #mainContent class="main-content" id="main-content" tabindex="-1" aria-label="Main content">
            <router-outlet (activate)="onRouteActivate(mainContent)"></router-outlet>
          </main>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </ng-container>
    <ng-template #loggedOut>
      <router-outlet></router-outlet>
    </ng-template>
  </ng-container>
</div>